<template>
  <div class="enterprise-class">
    <div class="btn">
      <el-button size="small" type="primary" @click="addProductArr">{{$lange=='en' ? 'Add' : '添加'}}</el-button>
    </div>
    <div class="product-lists">
      <div class="list" v-for="(item, index) in productArr">
        <div class="top flex-between">
          <div class="left">
            <el-input
              size="mini"
              v-if="item.isEdit"
              v-model="item.title"
              :placeholder="$lange=='en' ? 'Please input Product Name' : '请输入产品名称'"
            ></el-input>
            <p v-else>{{item.title}}</p>
          </div>
          <div class="right">
            <template v-if="item.isEdit">
              <el-button
                type="text"
                @click="saveProduct(item, index)"
              >{{$lange=='en' ? 'Save' : '保存'}}</el-button>
              <el-button
                type="text"
                @click="cancelEdit(item, index)"
              >{{$lange=='en' ? 'Cancel' : '取消'}}</el-button>
            </template>
            <el-button
              type="text"
              v-else
              @click="item.isEdit = true"
            >{{$lange=='en' ? 'Edit' : '编辑'}}</el-button>
            <el-button
              type="text"
              style="color: #F56c6c;"
              @click="deleteProduct(item)"
            >{{$lange=='en' ? 'Delete' : '删除'}}</el-button>
          </div>
        </div>
        <div class="bottom flex-between">
          <div class="image-box flex-between">
            <p>{{$lange=='en' ? 'Image' : '缩略图'}}:</p>

            <div
              class="image-show"
              :style="`background: url(${item.imageUrl}) no-repeat center / cover`"
            >
              <cc-uploader
                :config="uploaderConf2"
                uploadType="dottedLine"
                v-model="item.imageUrl"
                v-if="item.isEdit"
              />
            </div>
          </div>
          <div class="select-box flex-between">
            <div class="select-box">
              <p>
                {{$lange=='en' ? 'Url' : '跳转链接'}}:
                <span v-if="!item.isEdit">{{item.url}}</span>
              </p>
              <el-select
                v-model="item.url"
                size="mini"
                :placeholder=" $lange=='en' ? 'Please select a link' : '请选择跳转链接'"
                v-if="item.isEdit"
              >
                <el-option label="Pro/Line" value="Pro/Line"></el-option>
                <el-option label="S/Line" value="S/Line"></el-option>
              </el-select>
            </div>
            <div class="select-box">
              <p>
                {{$lange=='en`' ? 'Language' : '显示语言'}}:
                <span
                  v-if="!item.isEdit"
                >{{item.lange === 'zh' ? '中文' : '英文'}}</span>
              </p>
              <el-select
                v-model="item.lange"
                size="mini"
                :placeholder=" $lange=='en' ? 'Please select a language' : '请选择显示的语言版本'"
                v-if="item.isEdit"
              >
                <el-option :label="$lange=='en' ? 'Chinese' : '中文'" value="zh"></el-option>
                <el-option :label="$lange=='en' ? 'English' : '英文'" value="en"></el-option>
              </el-select>
            </div>
          </div>
          <div class="input-box flex-between">
            <p>{{$lange=='en' ? 'Describe' : '描述'}}:</p>
            <div v-if="item.isEdit">
              <el-input
                type="textarea"
                :rows="6"
                :placeholder=" $lange=='en' ? 'Please input Product Describe' : '请输入描述'"
                v-model="item.description"
              ></el-input>
            </div>
            <div v-else>{{item.description}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnterpriseClass",
  data() {
    return {
      uploaderConf2: this.$uploadUtils.config,
      productArr: [],
      lastProductArr: ""
    };
  },

  methods: {
    cancelEdit(item, idx) {
      console.log(item, idx);
      if (item.id > 0) {
        let arr = JSON.parse(this.lastProductArr);
        for (let i in item) {
          item[i] = arr[idx][i];
        }
        // this.productArr[idx] = arr[idx];
      } else {
        this.productArr.splice(idx, 1);
      }
    },
    deleteProduct(item) {
      this.$confirm("此操作会删除该产品, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = {
          id: item.id
        };
        this.ccRequest
          .do("admin/fsb/enterprise/product/class/delete", data, "GET")
          .then(res => {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.getProductData();
          });
      });
    },
    addProductArr() {
      this.productArr.unshift({
        id: -1,
        imageUrl: "",
        title: "",
        description: "",
        lange: "zh",
        url: "",
        isEdit: true
      });
    },
    saveProduct(item, index) {
      let data = {
        imageUrl: item.imageUrl,
        title: item.title,
        description: item.description,
        lange: item.lange,
        url: item.url
      };
      if (item.id > 0) {
        data.id = item.id;
      }
      let text = "参数错误";
      for (let i in data) {
        if (data[i] == "" && (i == "title" || i == "url" || i == "lange")) {
          i == "title" && (text = "请输入产品名称");
          i == "url" && (text = "请选择跳转链接");
          i == "lange" && (text = "请选择显示的语言版本");
          return this.$message({
            type: "warning",
            message: text
          });
        }
      }
      this.ccRequest
        .do("admin/fsb/enterprise/product/class/save", data, "POSTJSON")
        .then(res => {
          this.$message({
            type: "success",
            message: "保存成功"
          });
          this.getProductData();
        })
        .catch(res => {
          this.$message({
            type: "success",
            message: res.response.data.message
          });
        });
    },
    getProductData() {
      this.ccRequest
        .do("admin/fsb/enterprise/product/class/query", {}, "GET")
        .then(res => {
          for (let i in res.rows) {
            res.rows[i].isEdit = false;
          }
          this.lastProductArr = JSON.stringify(res.rows);
          this.productArr = res.rows;
        });
    },
    getData() {
      this.getProductData();
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped lang="scss">
.enterprise-class {
  background: #ffffff;
  min-height: 300px;
  .btn {
    padding: 20px;
    border-bottom: 5px solid #e4e4e4;
  }
  .product-lists {
    .list {
      padding: 20px;
      min-height: 140px;
      &:not(:last-child) {
        /*margin-bottom: 20px;*/
        border-bottom: 10px solid #e4e4e4;
        padding-bottom: 20px;
      }
      .bottom {
        margin-top: 20px;
        align-items: flex-start;
        & > :not(:last-child) {
          margin-right: 40px;
        }
        > * {
          align-items: flex-start;
          & > p {
            margin-right: 5px;
          }
          & > div {
            flex: 1;
          }
        }
        .image-box {
          flex: 0 15%;
          > .image-show {
            position: relative;
            height: 120px;
            border-radius: 3px;
            border: 1px dotted #e4e4e4;
          }
        }
        .select-box {
          flex: 0 40%;
        }
        .input-box {
          flex: 1;
        }
      }
    }
  }
}
</style>
